import React from "react";
import { Tooltip, IconButton } from "@mui/material";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import { useThemeMode } from "../../context/ThemeContext";

type ThemeToggleProps = {
  hidden?: boolean;
};

const ThemeToggle: React.FC<ThemeToggleProps> = ({ hidden }) => {
  const { mode, toggleTheme } = useThemeMode();

  if (hidden) return null;

  return (
    <Tooltip title={mode === "dark" ? "Switch to Light Mode" : "Switch to Dark Mode"}>
      <IconButton
        onClick={toggleTheme}
        sx={{
          bgcolor: "transparent",
          transition: "all 0.2s ease",
          color: "text.secondary",
          "&:hover": {
            color: "primary.main",
            bgcolor: (theme) => theme.palette.primary.main + "15",
          },
        }}
      >
        {mode === "dark" ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggle;


